class FilterInfo {
    constructor(json) {
        if (json != null) {
            this.filterType = json.filterType || '';
            this.filterClass = json.filterClass || '';
            this.filterEfficiency = json.filterEfficiency;
            this.material = json.material || '';
            this.dimensionWidth = json.dimensionWidth || 0;
            this.dimensionHeight = json.dimensionHeight || 0;
            this.maxDepth = json.maxDepth || 0;
            this.count = json.count || 0;
            this.heatRecoveryModel = json.heatRecoveryModel || '';
            this.filterTypeOtherDescription = json.filterTypeOtherDescription || '';
            this.machineUid = json.machineUid;
            this.suggestedProductIds = Array.isArray(json.suggestedProductIds) ? json.suggestedProductIds : [];
            this.productMaterialSpeeds = Array.isArray(json.productMaterialSpeeds) ? json.productMaterialSpeeds : [];
        } else {
            this.filterType = '';
            this.filterClass = '';
            this.filterEfficiency = 0;
            this.material = '';
            this.dimensionWidth = 0;
            this.dimensionHeight = 0;
            this.maxDepth = 0;
            this.count = 0;
            this.heatRecoveryModel = '';
            this.filterTypeOtherDescription = '';
            this.machineUid = null;
            this.suggestedProductIds = [];
            this.productMaterialSpeeds = [];
        }
    }
}

export default FilterInfo;
